import React, { useContext } from "react";
import { AuthContext } from "../../context/AuthContext";
import FormClients from '../../components/Clients/FormClients';
import AdminLayout from "../../layouts/AdminLayout";

// (2026-05-15) Alta/edición de un Tercero del emisor: reutiliza el Form de
// Clientes en modo "terceros" (es_tercero=true + padre = cliente del usuario,
// asignados automáticamente). Ruta protegida solo para operador_admin.
export default function FormTercerosPage() {
  const { user } = useContext(AuthContext);
  const nombreUsuario = user?.nombre || "Usuario";

  return (
    <AdminLayout nombreUsuario={nombreUsuario}>
      <div className="mt-8 px-4 md:px-8">
        <FormClients mode="terceros" />
      </div>
    </AdminLayout>
  );
}
